module.exports = __webpack_public_path__ + "img/43t.7ab45bab.jpg";